// src/pages/account/AccountHome.tsx
import React from "react";
import { Callout, Spinner, Button } from "@blueprintjs/core";
import { useAuth } from "../../auth/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AccountHome() {
  const { userName, tier, loading } = useAuth();
  const navigate = useNavigate();

  /* ─── 1. still loading ─────────────────────────────── */
  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Spinner intent="primary" size={40} />
      </div>
    );
  }

  /* ─── 2. not logged-in ─ prompt to sign-in via Cognito ─ */
  if (!userName) {
    return (
      <div style={{ textAlign: "center", padding: "4rem" }}>
        <Callout
          title="Not signed in"
          intent="warning"
          style={{ maxWidth: 480, marginInline: "auto" }}
        >
          <p style={{ marginBottom: "1rem" }}>
            You need to sign in to view your account details.
          </p>
          <Button intent="primary" onClick={() => navigate('/login')}>
            Sign in
          </Button>
        </Callout>
      </div>
    );
  }

  /* ─── 3. logged-in ─ show profile ───────────────────── */
  return (
    <div style={{ textAlign: "center", padding: "4rem" }}>
      <Callout
        title="Account overview"
        intent="primary"
        style={{
          marginBottom: "2rem",
          maxWidth: "600px",
          marginInline: "auto",
        }}
      >
        <p style={{ marginBottom: "0.5rem" }}>
          <strong>Email:</strong> {userName}
        </p>
        <p style={{ marginBottom: 0 }}>
          <strong>Subscription tier:</strong> {tier ?? "free"}
        </p>
      </Callout>
    </div>
  );
}
